<div class="milestone" *editionFeature="'okrs.kr-milestones'" [formGroup]="form">
  <ng-container formArrayName="milestones">
    <ng-container *ngFor="let milestoneForm of milestones.controls; let i = index; let isLast = last" [formGroup]="milestoneForm">
      <label class="milestone__tag" [for]="'metric-milestone-' + i">
        <span>{{ "milestone" | localize }}</span>
      </label>
      <metric-number-input-field
        class="milestone__value"
        id="milestone"
        [uiId]="'metric-milestone-' + i"
        [placeholder]="'select_value' | localize"
        [status]="!!errorTranslationKey && i === 0 ? 'error' : null"
        [focus]="isLast && addMilestoneBtnIsClicked"
        formControlName="targetValue"></metric-number-input-field>
      <ui-date-picker
        [uiDefaultPickerValue]="defaultDate"
        [uiBackdrop]="true"
        [uiOpen]="false"
        [uiDisabledDate]="checkIfDateIsDisabled"
        (keydown.enter)="$event.preventDefault()"
        formControlName="date"></ui-date-picker>
      <button class="milestone__delete-btn" [attr.aria-label]="('delete' | localize) + ' ' + ('milestone' | localize)" (click)="removeMilestone(i)" ui-button>
        <i class="delete-button" ui-icon uiType="trash-bin"></i>
      </button>
      <ui-validation-hint
        class="milestone__error-message"
        *ngIf="i === 0 && !!errorTranslationKey"
        [hintContent]="errorTranslationKey | localize"
        [uiHideIcon]="true"
        role="alert"
        hintType="error"></ui-validation-hint>
    </ng-container>
  </ng-container>

  <button class="milestone__add-btn" (click)="addMilestone()" ui-button uiShape="round" uiType="link" uiSize="default">
    <i ui-icon uiTheme="outline" uiType="plus"></i>{{ "add_milestone" | localize }}
  </button>
</div>
